interface EventBusEvent {
  [key: string]: Array<(...args: any[]) => void>;
}

class EventBusClass {
    private events: EventBusEvent = {};

    $on(event: string, callback: (...args: any[]) => void): void {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    $off(event: string, callback?: (...args: any[]) => void): void {
        if (!this.events[event]) return;

        if (callback) {
            this.events[event] = this.events[event].filter(cb => cb !== callback);
        } else {
            delete this.events[event];
        }
    }

    $emit(event: string, ...args: any[]): void {
        if (!this.events[event]) return;

        this.events[event].forEach(callback => {
            callback(...args);
        });
    }

    $once(event: string, callback: (...args: any[]) => void): void {
        const onceCallback = (...args: any[]) => {
            callback(...args);
            this.$off(event, onceCallback);
        };
        this.$on(event, onceCallback);
    }
}

export const EventBus = new EventBusClass();
